<!--
-- 대진표
-->
<style lang="scss" scoped>
    .gt-wrap{
        /*display: table-row;
        */
        >div{
            border-bottom: 1px solid #ebebeb;
        }
        >div:last-child{
            border: none;
        }
    }

    .participation-table{
        td{
            /*vertical-align: middle;*/
            border-bottom: 1px solid #ebebeb !important;
        }
    }

    .participation-list-wrap{
        height: calc(100% - 60px - 50px);
        overflow: auto;
    }
</style>
<template>
    <div class="participant-list" :class="isMobile ? '' : 'window'">
        <TournamentFilter></TournamentFilter>

        <div class="tournament-title"><p>{{tournament.tnmtName}}</p></div>
        <div class="participation-list-wrap"  ref="tournamentList" v-on:scroll="handleScroll">
            <table class="participation-table">
                <thead>
                <tr>
                    <th>세부종목</th>
                    <th>출전팀</th>
                    <th>경기방식</th>
                    <th>총 {{category.playingCategoryList.length}}건</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(row, rowIndex) in category.playingCategoryList" :key="rowIndex">
                    <td>{{row.eventName}} {{row.age}} {{row.level}}</td>
                    <td>{{row.numOfTeam}}팀</td>
                    <td v-if="row.tnmtTreeOption !== 'GT'">
                        {{row.tnmtTreeOption === 'FL' ? '풀리그' : getFullTournamentTreeOption(row)}}
                    </td>
                    <td v-else>
                        <div class="gt-wrap">
                            <div>예선 {{row.numOfDivision}}조</div>
                            <div>{{`${getMainTournamentTreeOption(row)}`}}</div>
                        </div>
                            </td>
                    <td v-if="row.tnmtTreeOption !== 'GT'">  <p class="player-detail" @click="detailLocationFunc(null, row)">대진표</p></td>
                    <td v-else>
                        <div class="gt-wrap">
                            <div>
                                <p class="player-detail" @click="detailLocationFunc(`league`, row)">대진표</p>
                            </div>
                            <div>
                                <p class="player-detail" @click="detailLocationFunc('tournament', row)">대진표</p>
                            </div>

                        </div>
                    </td>
                </tr>
                <tr></tr>
                <tr v-if="category.playingCategoryList.length <= 0">
                    <td colspan="4" style="vertical-align: middle">
                         <div class="empty-list-wrap">
                             <div class="empty-list">
                                 <div></div>
                                 <p>검색결과가 없습니다.</p>
                             </div>
                         </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>


<script>
    import TournamentFilter from './TournamentFilter'
    import {mapState} from 'vuex'

    export default {
        components: { TournamentFilter},
        computed: {
            ...mapState('tournaments', ['tournament', 'category']),
            ...mapState('filters', ['type', 'event', 'age', 'level'])
        },
        data() {
            return {
                tnmtId: this.$route.params.tnmtId,

                filterShow: false,
                filters: null
            }
        },
        methods: {
            filterFunc() {
                this.filterShow = true
            },
            filterClose(filter) {
                this.filterShow = false
                this.filters = filter
            },
            getTournamentTreeOption(tournament){
                if(tournament.numOfDivision){

                    for(let i=1; i<11; i++){
                        if(tournament.numOfDivision > Math.pow(2, (i-1)) && tournament.numOfDivision <= Math.pow(2, i)){
                            if(i===1){
                                return '예선 결승';
                            }else if(i===2){
                                return '예선 준결승';
                            }else{
                                return `예선 ${Math.pow(2, i)}조`;
                            }

                        }
                    }
                }
            },
            getMainTournamentTreeOption(tournament){
                if(tournament.numOfKnockoutRound){
                    for(let i=1; i<11; i++){
                        if(tournament.numOfKnockoutRound > Math.pow(2, (i-1)) && tournament.numOfKnockoutRound <= Math.pow(2, i)){
                            if(i===1){
                                return '본선 결승';
                            }else if(i===2){
                                return '본선 준결승';
                            }else{
                                return `본선 ${Math.pow(2, i)}강`;
                            }

                        }
                    }
                }
            },
            getFullTournamentTreeOption(tournament){
                if(tournament.numOfKnockoutRound){
                    for(let i=1; i<11; i++){
                        if(tournament.numOfKnockoutRound > Math.pow(2, (i-1)) && tournament.numOfKnockoutRound <= Math.pow(2, i)){
                            if(i===1){
                                return '본선 결승';
                            }else if(i===2){
                                return '본선 준결승';
                            }else{
                                return `본선 ${Math.pow(2, i)}강`;
                            }

                        }
                    }
                }
            },
            detailLocationFunc(type, category){
                if(type === 'tournament'){
                    this.$router.push(`/tournament/${this.tournament.tnmtId}/figure/tournament/${category.playingCategoryId}?type=${category.tnmtTreeOption}`)
                }else if(type === 'league'){
                    this.$router.push(`/tournament/${this.tournament.tnmtId}/figure/league/${category.playingCategoryId}?type=${category.tnmtTreeOption}`)
                }else{
                    if(category.tnmtTreeOption == 'FT'){
                        this.$router.push(`/tournament/${this.tournament.tnmtId}/figure/tournament/${category.playingCategoryId}?type=${category.tnmtTreeOption}`)
                    }else{
                        this.$router.push(`/tournament/${this.tournament.tnmtId}/figure/league/${category.playingCategoryId}?type=${category.tnmtTreeOption}`)
                    }
                }
            },
            handleScroll(event){
                const scrollTop = event.target.scrollTop
                localStorage.setItem(this.$route.name, scrollTop)
            },
        },
        mounted() {
            if(localStorage.getItem(this.$route.name)){
                this.$refs.tournamentList.scrollTop = localStorage.getItem(this.$route.name)
            }
        },
        created() {
            window.addEventListener('scroll', this.handleScroll)
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll);
        },
    }
</script>
